import { render, staticRenderFns } from "./ViewGroup.vue?vue&type=template&id=2da0d420&scoped=true"
import script from "./ViewGroup.vue?vue&type=script&lang=js"
export * from "./ViewGroup.vue?vue&type=script&lang=js"
import style0 from "./ViewGroup.vue?vue&type=style&index=0&id=2da0d420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0d420",
  null
  
)

export default component.exports